/**
 * 🎨 RINTINTIN DESIGN SYSTEM - TOKENS INDEX
 * ========================================
 * 
 * Point d'entrée unique pour tous les tokens de design
 * Facilite l'importation et la réutilisation
 */

// ==========================================
// TOKENS PRINCIPAUX
// ==========================================
export * from './colors';
export * from './typography';
export * from './spacing';

// ==========================================
// THÈME PRINCIPAL
// ==========================================
import { colors, getColor } from './colors';
import { 
  fontFamilies, 
  fontSizes, 
  fontWeights, 
  lineHeights, 
  letterSpacings,
  textStyles,
  getTextStyle
} from './typography';
import { 
  spacing, 
  spacingAliases, 
  borderRadius, 
  shadows, 
  sizes,
  getSpacing,
  getSpacingAlias,
  spacingUtils
} from './spacing';

// ==========================================
// THÈME UNIFIÉ
// ==========================================
export const theme = {
  // Couleurs
  colors,
  
  // Typographie
  fontFamilies,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  textStyles,
  
  // Espacements
  spacing,
  spacingAliases,
  borderRadius,
  shadows,
  sizes,
  
  // Utilitaires
  utils: {
    getColor,
    getTextStyle,
    getSpacing,
    getSpacingAlias,
    spacingUtils,
  },
} as const;

// ==========================================
// TYPE DU THÈME
// ==========================================
export type Theme = typeof theme;

// ==========================================
// CONFIGURATION BREAKPOINTS (responsive)
// ==========================================
export const breakpoints = {
  xs: '0px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  '2xl': '1400px',
} as const;

// ==========================================
// Z-INDEX SYSTÈME
// ==========================================
export const zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
  docked: 10,
  dropdown: 1000,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800,
} as const;

// ==========================================
// ANIMATIONS ET TRANSITIONS
// ==========================================
export const animations = {
  // Durées
  durations: {
    fast: '150ms',
    normal: '200ms',
    slow: '300ms',
    slower: '500ms',
  },
  
  // Easing functions
  easings: {
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    easeOut: 'cubic-bezier(0, 0, 0.2, 1)',
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  },
  
  // Transitions communes
  transitions: {
    default: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1)',
    fast: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
    color: 'color 200ms cubic-bezier(0.4, 0, 0.2, 1)',
    background: 'background-color 200ms cubic-bezier(0.4, 0, 0.2, 1)',
    transform: 'transform 200ms cubic-bezier(0.4, 0, 0.2, 1)',
    opacity: 'opacity 200ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
} as const;

// ==========================================
// EXPORT PAR DÉFAUT
// ==========================================
export default theme;
